import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ReportCreated } from '../../interfaces/report/report-created';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import * as _ from 'lodash';
import { trim } from '../../../@fury/utils/trim';

@Injectable()

export class WebformService {

  public normalForm = this.fb.group({
    form_filling_start_at: null,
    head_category_id: new FormControl(null, {validators: Validators.required}),
    sub_category_id: new FormControl(null),
    description: new FormControl('', {validators: [Validators.required, trim(), Validators.pattern(/^(?!\s*$)(?!\d+\s*$).+/), Validators.maxLength(5000)]}),
    attachments: this.fb.array([]),
    attachmentsContainer: [''],
    report_location: new FormControl(null, {validators: Validators.required}),
    report_location_description: new FormControl('', {validators: [trim(), Validators.maxLength(500)]}),
    report_postalcode: null,
    report_house_number_with_addition: null,
    report_streetname: null,
    report_city: null,
    report_lat: null,
    report_lng: null,
    reporter_anonymous: new FormControl(false, {validators: Validators.required, nonNullable: true}),
    reporter_prefix: new FormControl('Neutraal', {validators: Validators.required, nonNullable: true}),
    reporter_initials: null,
    reporter_lastname: new FormControl(null, {validators: Validators.required}),
    reporter_location: <string>null,
    reporter_postalcode: <string>null,
    reporter_house_number_with_addition: <string>null,
    reporter_streetname: <string>null,
    reporter_city: <string>null,
    reporter_lat: null,
    reporter_lng: null,
    reporter_email: new FormControl(null, {validators: [Validators.required, Validators.email], nonNullable: true}),
    reporter_phone: null,
//    reporter_phone: new FormControl(null, {validators: [Validators.pattern(/^\d{0,10}$/)]}),
    reporter_notify: new FormControl(true, {validators: Validators.required, nonNullable: true}),
  });

  public checkForm: boolean = false;
  public report: ReportCreated = null;
  public apiErrors: any[] = [];
  public hasValidErrors: boolean = false;
  public normalFormErrors = null;

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
              private fb: FormBuilder,
  ) {
  }

  get(id: string): Observable<ServerResponse> {
    return this.api.get(this.apiEndpoints.get('webform.reports.read', {':unique_number': id}));
  }

  save(formData: any): Observable<number | ReportCreated | boolean> {
    return new Observable<number | ReportCreated | boolean>((o: Subscriber<number | ReportCreated | boolean>): void => {
      this.api.postWithProgress(this.apiEndpoints.get('webform.reports.create'), formData).subscribe({
        next: (event: HttpEvent<any>) => {
          if (event.type === HttpEventType.UploadProgress && event.total) {
            o.next(Math.round((event.loaded / event.total) * 100));
          }

          if (event.type === HttpEventType.Response) {
            if (typeof event.body.data !== 'undefined') {
              o.next(event.body.data as ReportCreated);
            }
            o.complete();
          }
        },
        error: (res): void => {
          const error: { message: string } = {
            message: null
          };
          if (typeof res.message !== 'undefined') {
            error.message = res.message;
          }
          this.apiErrors.push(error);
          this.hasValidErrors = !_.isEmpty(res.errors);

          if (!_.isEmpty(res.errors)) {
            this.normalFormErrors = res.errors;
          } else {
            this.normalFormErrors = null;
          }

          o.next(false);
        }
      });
    });
  }

  forwardFailedReport(formData: any): Observable<boolean> {
    return new Observable<boolean>((o: Subscriber<boolean>): void => {
      this.api.post(this.apiEndpoints.get('webform.reports.failed'), {...formData, ...{errors: this.apiErrors}}).subscribe(
        (response: ServerResponse): void => {
          if (!this.api.isErrorResponse(response)) {
            o.next(true);
          }
        },
        (): void => o.next(false)
      );
    });
  }
}
